import { isAnyOf } from "@reduxjs/toolkit";
import { appListenerMiddleware } from "../../appListenerMiddleware";
import {
  resetProfile,
  setProfile,
} from "../../../../../features/Modals/ProfileModal/redux/slice";
import { RootState } from "../../../types";
import { saveProfileData } from "../../../../../features/Modals/ProfileModal/helpers";

export function appProfileListener() {
  appListenerMiddleware.startListening({
    matcher: isAnyOf(setProfile, resetProfile),
    effect: (_, api) => {
      const { profile } = (api.getState() as RootState).profileState;
      saveProfileData(profile);
    },
  });
}
